module.exports = __webpack_public_path__ + "img/Api.701b548.svg";